module.exports = __webpack_public_path__ + "/images/promos_home.13bda77.webp";